// Module
var code = "<div> </div>";
// Exports
var _module_exports = code;;
var path = 'app/authentication/components/auth-page/auth-login.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;